var _path, _g, _g2, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCyphlensLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 244,
    viewBox: "0 0 249 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.9407 32.9956C64.4704 24.8705 45.6543 26.0446 35.6194 36.436C25.5848 46.8276 25.0689 65.673 34.0081 88.8452C42.8596 111.79 60.6617 137.986 85.3987 161.875C110.136 185.763 136.937 202.64 160.177 210.685C183.647 218.81 202.463 217.637 212.498 207.246C222.533 196.854 223.049 178.009 214.11 154.836C205.258 131.891 187.456 105.695 162.719 81.8071C137.982 57.9188 111.181 41.041 87.9407 32.9956ZM207.874 214.119C207.52 214.317 207.159 214.506 206.795 214.691C206.933 214.621 207.07 214.553 207.206 214.481L207.874 214.119ZM40.9231 41.5571C47.7625 34.4748 62.6226 32.0327 85.5286 39.9624C107.544 47.5839 133.454 63.7949 157.598 87.1108C181.742 110.427 198.847 135.754 207.232 157.49C215.956 180.105 214.034 195.042 207.195 202.125C200.355 209.207 185.495 211.648 162.589 203.718C140.574 196.097 114.665 179.887 90.5208 156.571C66.3764 133.255 49.2712 107.927 40.886 86.1909C32.1618 63.5757 34.0838 48.6394 40.9231 41.5571ZM146.618 194.025C146.981 194.207 147.343 194.386 147.704 194.564L148.787 195.091C148.427 194.918 148.067 194.742 147.705 194.564L146.618 194.025ZM185.877 103.016C186.197 103.408 186.514 103.8 186.829 104.192L187.771 105.368C187.459 104.976 187.146 104.584 186.83 104.192L185.877 103.016ZM39.6301 73.5659C39.7047 73.8646 39.7814 74.1654 39.8606 74.4683L40.1057 75.3823C40.0218 75.0756 39.9407 74.7708 39.8616 74.4683L39.6301 73.5659ZM40.2346 47.1343C40.1668 47.2681 40.1 47.4038 40.0344 47.5415L39.8421 47.9604C39.9053 47.8188 39.9699 47.6793 40.0354 47.5415L40.2346 47.1343ZM79.0413 27.5513C79.3945 27.6396 79.7485 27.7309 80.1038 27.8237L81.1731 28.1089C80.816 28.0117 80.4599 27.9165 80.1048 27.8237L79.0413 27.5513Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_9528_2367)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.733 85.2322C213.367 62.8496 210.963 49.3096 205.266 43.4101C199.569 37.5106 186.121 34.6351 163.45 42.4833C141.878 49.9515 116.292 65.9204 92.3618 89.0292C68.4319 112.138 51.5797 137.151 43.3632 158.45C34.7286 180.833 37.133 194.373 42.8301 200.272C48.5272 206.172 61.975 209.047 84.6454 201.199C106.218 193.731 131.804 177.762 155.734 154.653C179.664 131.544 196.516 106.531 204.733 85.2322ZM164.56 163.793C214.463 115.602 236.78 57.7532 214.405 34.5838C192.031 11.4145 133.439 31.6985 83.5356 79.8894C33.6325 128.08 11.316 185.929 33.6903 209.098C56.0646 232.268 114.657 211.984 164.56 163.793Z",
    fill: "url(#paint0_linear_9528_2367)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_9528_2367)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.733 85.2322C213.367 62.8496 210.963 49.3096 205.266 43.4101C199.569 37.5106 186.121 34.6351 163.45 42.4833C141.878 49.9515 116.292 65.9204 92.3618 89.0292C68.4319 112.138 51.5797 137.151 43.3632 158.45C34.7286 180.833 37.133 194.373 42.8301 200.272C48.5272 206.172 61.975 209.047 84.6454 201.199C106.218 193.731 131.804 177.762 155.734 154.653C179.664 131.544 196.516 106.531 204.733 85.2322ZM164.56 163.793C214.463 115.602 236.78 57.7532 214.405 34.5838C192.031 11.4145 133.439 31.6985 83.5356 79.8894C33.6325 128.08 11.316 185.929 33.6903 209.098C56.0646 232.268 114.657 211.984 164.56 163.793Z",
    fill: "url(#paint1_linear_9528_2367)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.733 85.2302C213.368 62.8476 210.963 49.3076 205.266 43.4081C199.569 37.5086 186.121 34.6331 163.451 42.4813C141.878 49.9495 116.292 65.9184 92.3623 89.0273C68.4324 112.136 51.5802 137.149 43.3637 158.448C34.7291 180.831 37.1335 194.371 42.8306 200.27C48.5277 206.17 61.9755 209.045 84.6459 201.197C106.218 193.729 131.805 177.76 155.734 154.651C179.664 131.542 196.517 106.529 204.733 85.2302ZM164.561 163.791C214.464 115.6 236.78 57.7512 214.406 34.5819C192.032 11.4126 133.439 31.6966 83.5361 79.8875C33.6329 128.078 11.3164 185.927 33.6908 209.097C56.0651 232.266 114.658 211.982 164.561 163.791Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9528_2367",
    x: -0.000488281,
    y: 0.000488281,
    width: 248.097,
    height: 243.681,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_9528_2367"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_9528_2367",
    x: -0.000488281,
    y: 0.000488281,
    width: 248.097,
    height: 243.681,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_9528_2367"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9528_2367",
    x1: 223.107,
    y1: -8.33239,
    x2: 31.4399,
    y2: 233.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5200FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9528_2367",
    x1: 223.107,
    y1: -8.33239,
    x2: 31.4399,
    y2: 233.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF38A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A383FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyphlensLogo);
export default __webpack_public_path__ + "static/media/cyphlensLogo.ccc90fe87218f9d13800aea2222cba6a.svg";
export { ForwardRef as ReactComponent };